import React from 'react';
import {IconButton ,Drawer, withStyles, WithStyles } from '@material-ui/core';
import { GuiaDetallePanelStyles } from '../../styles';
// import styles from '../../styles/GuiaDetallePanel.module.css';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import {CardDetalleEnvio} from '../atoms';

interface GuiaDetallePanelProp extends WithStyles<typeof GuiaDetallePanelStyles> {
    open:boolean;
    handleClose: ()=>void;
    children?: React.ReactNode;
    className?: string;
  }
const GuiaDetallePanelComponent = (props:GuiaDetallePanelProp) => { 
    const classes = props.classes;
    // const classes = styles;
    return (
        <Drawer className={ classes.root} variant="persistent" anchor="right" open={props.open}>
            <div className={classes.drawerHeader}>
                <IconButton id="icon-detalle" onClick={props.handleClose}>
                    <ChevronLeftIcon />
                </IconButton>
                Detalle
            </div>
            <div className={classes.detalle}><CardDetalleEnvio /></div>
        </Drawer>
    );
}
export const GuiaDetallePanel = withStyles(GuiaDetallePanelStyles)(GuiaDetallePanelComponent)
